import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { useAnnouncement } from '@context/AnnouncementContext';
import { muiSeverity } from './severity';

/**
 * Banner fijo con el título del comunicado vigente.
 *
 * Su visibilidad está desacoplada del descarte del modal: mientras haya un
 * comunicado activo, el banner sigue ahí para poder reabrirlo.
 */
const AnnouncementBanner = () => {
  const { announcement, openModal } = useAnnouncement();

  if (!announcement) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        // Justo debajo del AppBar fijo (56px en móvil, 64px de sm en adelante).
        top: { xs: '56px', sm: '64px' },
        zIndex: 1100, // Por debajo del AppBar (1300) y del Drawer (1200).
        mb: 2,
      }}
    >
      <Alert
        severity={muiSeverity(announcement.severity)}
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={openModal} sx={{ fontWeight: 700 }}>
            Ver
          </Button>
        }
        sx={{ alignItems: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
      >
        <AlertTitle sx={{ mb: 0, fontWeight: 700 }}>{announcement.title}</AlertTitle>
      </Alert>
    </Box>
  );
};

export default AnnouncementBanner;
